var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('article', [_c('activity-stage', [_c('template', {
    slot: "instructions"
  }, [_vm._t("instructions")], 2), _c('article', {
    staticClass: "a-sentences-wpm",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('assessment-helper'), _vm.currentRound.activitySentences ? _c('article', {
    staticClass: "steps-container typing-stage",
    attrs: {
      "transition": "fade"
    }
  }, _vm._l(_vm.currentRound.activitySentences, function (step, index) {
    return _c('div', {
      key: index,
      staticClass: "step text-display-container"
    }, [_c('blinking-cursor-text', {
      attrs: {
        "text": step,
        "text-step": index
      }
    })], 1);
  }), 0) : _vm._e()], 1)], 2), _vm._t("keyboard")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }